import * as React from "react";
import { connect } from "react-redux";

import {
  Divider,
  Fade,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
  withStyles,
} from "@material-ui/core";

import { AdvisorFeeDataBox, TieredFeeDataBox } from "../Cy/components";

import { appAction, feeAction } from "../../actions";

import SectionHeader from "../../components/UI/SectionHeader";

const styles = (theme) => ({
  contentWrapper: {
    width: "100%",
    display: `flex`,
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      paddingLeft: "5%",
    },
  },
  feeListItem: {
    background: theme.palette.grey[100],
  },
});

class AdminFees extends React.Component {
  state = {
    custodianIdWithFeeLoaded: null,
    loadedFeeType: "advisor",
  };

  loadFeeSchedule = (feeType, custodianId) => (e) => {
    this.setState({
      loadedFeeType: feeType,
      custodianIdWithFeeLoaded: feeType === "custodian" ? custodianId : null,
    });
  };

  saveFeeSchedule = (entityType, entityId) => (feeSchedules) => {
    const { dispatch } = this.props;

    if (entityType === "custodian") {
      dispatch(feeAction.updateDefaultCustodian(feeSchedules, entityId));
    } else if (entityType === "platform") {
      dispatch(feeAction.updateDefaultPlatform(feeSchedules));
    } else {
      throw new Error("unknown action");
    }
    // TODO: connect to action
  };

  componentDidMount() {
    this.props.dispatch(appAction.setAdminNav(true));
    this.props.dispatch(appAction.toggleMainNav(false));
    window.scrollTo(0, 0);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {}

  render() {
    const { cyCustodianFees, cyPlatformFees, classes, custodians } = this.props;

    const { custodianIdWithFeeLoaded, loadedFeeType } = this.state;

    return (
      <Fade in>
        <div className={classes.contentWrapper}>
          <div className={classes.content}>
            <Grid container>
              <Grid item xs={12}>
                <SectionHeader text={"Fees"} />
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} sm={3}>
                <List data-cy="admin.fees.list">
                  <ListItem
                    className={classes.feeListItem}
                    button
                    selected={loadedFeeType === "advisor"}
                    onClick={this.loadFeeSchedule("advisor")}
                  >
                    <ListItemText
                      primary="Advisor Fee"
                      primaryTypographyProps={{ variant: "body1" }}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem
                    className={classes.feeListItem}
                    button
                    selected={loadedFeeType === "platform"}
                    onClick={this.loadFeeSchedule("platform")}
                  >
                    <ListItemText
                      primary="Platform Fee"
                      primaryTypographyProps={{ variant: "body1" }}
                    />
                  </ListItem>
                  <Divider />
                  {custodians.map((custodian) => (
                    <React.Fragment key={custodian.id}>
                      <ListItem
                        className={classes.feeListItem}
                        button
                        selected={
                          loadedFeeType === "custodian" &&
                          custodian.id === custodianIdWithFeeLoaded
                        }
                        onClick={this.loadFeeSchedule(
                          "custodian",
                          custodian.id
                        )}
                      >
                        <ListItemText
                          primary="Custodian Fee"
                          primaryTypographyProps={{ variant: "caption" }}
                          secondary={custodian.name}
                          secondaryTypographyProps={{
                            variant: "body1",
                            color:
                              custodian.id === custodianIdWithFeeLoaded
                                ? "primary"
                                : "initial",
                          }}
                        />
                      </ListItem>
                      <Divider />
                    </React.Fragment>
                  ))}
                </List>
              </Grid>
              <Grid item xs={12} sm={1} />
              <Grid item xs={12} sm={6}>
                {loadedFeeType === "advisor" && <AdvisorFeeDataBox />}
                {loadedFeeType === "platform" && (
                  <TieredFeeDataBox
                    title={
                      <Typography variant={"h5"} gutterBottom>
                        Platform Fee
                      </Typography>
                    }
                    description={
                      <Typography variant={"body1"} gutterBottom>
                        Fixed fees cannot be overridden by advisors
                      </Typography>
                    }
                    readonly={true}
                    onSaveFeeSchedules={this.saveFeeSchedule("platform")}
                    feeSchedules={cyPlatformFees}
                  />
                )}
                {loadedFeeType === "custodian" && custodianIdWithFeeLoaded && (
                  <React.Fragment>
                    <TieredFeeDataBox
                      key={custodianIdWithFeeLoaded}
                      title={
                        <Typography variant={"h5"} gutterBottom>
                          {
                            custodians.find(
                              (c) => c.id === custodianIdWithFeeLoaded
                            ).name
                          }
                        </Typography>
                      }
                      description={
                        <Typography variant={"body1"} gutterBottom>
                          Default values{" "}
                          {custodians.find(
                            (c) => c.id === custodianIdWithFeeLoaded
                          ).allowDefaultFeeOverride === false
                            ? "cannot be"
                            : "may be"}{" "}
                          overridden by advisors
                        </Typography>
                      }
                      onSaveFeeSchedules={this.saveFeeSchedule(
                        "custodian",
                        custodianIdWithFeeLoaded
                      )}
                      feeSchedules={cyCustodianFees[custodianIdWithFeeLoaded]}
                    />
                    <Typography variant={"body1"} gutterBottom>
                    {
                      custodians.find(
                      (c) => c.id === custodianIdWithFeeLoaded
                      ).feeDisclaimer
                    }
                    </Typography>
                  </React.Fragment>
                )}
              </Grid>
            </Grid>
          </div>
        </div>
      </Fade>
    );
  }
}

const mapStateToProps = (state) => {
  const custodianMap = state.custodian.map;
  const custodians = Object.values(custodianMap).sort(function (a, b) {
    if (a.name > b.name) return 1;
    else if (a.name < b.name) return -1;
    else return 0;
  });

  const { cyCustodianFees, cyPlatformFees } = state.fee;

  return {
    app: state.app,
    user: state.user,
    cyCustodianFees,
    cyPlatformFees,
    portfolio: state.portfolio,
    custodians,
    custodianMap,
  };
};
export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(AdminFees)
);



// WEBPACK FOOTER //
// ./src/containers/AdminFees/index.jsx